export default __webpack_public_path__ + "static/media/en.5ed98924.svg";